import { CurrencyCode, TableCell, TableRow, toCurrencyString } from '@client/toolkit';
import { TableExpandableCell } from '../../components/table-expanable-cell';
import React from 'react';
import { InvoiceRow } from './invoice-row';
import { TenantOverdueInvoicesDto, OverdueInvoiceDto } from '@client/api';

export const TenantRow = ({
  tenant,
  handleToggleExpand,
  handleKeyDownExpand,
  expandedRows,
}: {
  tenant: TenantOverdueInvoicesDto;
  handleToggleExpand: (id: string) => void;
  handleKeyDownExpand: (e: React.KeyboardEvent<Element>, id: string) => void;
  expandedRows: Set<string>;
}) => {
  return (
    <React.Fragment key={tenant.tenantId}>
      <TableRow className="bg-surface-base border-b border-surface-elevated">
        <TableCell className="px-2 py-2"></TableCell>
        <TableCell className="px-2 py-2"></TableCell>
        <TableExpandableCell
          label={tenant.tenantName}
          onClick={() => handleToggleExpand(tenant.tenantId)}
          onKeyDown={(e) => handleKeyDownExpand(e, tenant.tenantId)}
          ariaLabel={expandedRows.has(tenant.tenantId) ? `Lukk ${tenant.tenantName}` : `Åpne ${tenant.tenantName}`}
          isExpanded={expandedRows.has(tenant.tenantId)}
        />
        <TableCell className="px-2 py-2 align-top">
          {toCurrencyString(tenant.currentPeriodOutstanding.value, '-', {
            currency: tenant.currentPeriodOutstanding.currency as CurrencyCode,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })}
        </TableCell>
        <TableCell className="px-2 py-2 align-top">{tenant.invoices.length} fakturaer</TableCell>
        <TableCell className="px-2 py-2 align-top">-</TableCell>
        <TableCell className="px-2 py-2 align-top">-</TableCell>
        <TableCell className="px-2 py-2 align-top">-</TableCell>
      </TableRow>
      {expandedRows.has(tenant.tenantId) &&
        tenant.invoices?.map((invoice: OverdueInvoiceDto) => <InvoiceRow key={invoice.invoiceId} invoice={invoice} />)}
    </React.Fragment>
  );
};
